import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateAnnouncementForm from "../../forms/CreateOrUpdateAnnouncementForm";
import { AnnouncementResponseDto } from "../../shared/dtos/announcement/AnnouncementResponseDto";

interface UpdateAnnouncementModalProps {
  open: boolean;
  onClose: () => void;
  announcement: AnnouncementResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateAnnouncementModal: React.FC<UpdateAnnouncementModalProps> = ({
  open,
  onClose,
  announcement,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Edit Announcement"
    width="md"
    loading={loading}
  >
    <CreateOrUpdateAnnouncementForm
      isEditing={true}
      announcement={announcement}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateAnnouncementModal;
